import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/dashboard/metrics/_details/knowledge/")({
  
});
